import { createSlice } from "@reduxjs/toolkit";
import { SettingsInitialStatus } from "../../../types/settings/settings";
import {
  getActivityLogAsync,
  getAllLoginAccessLogAsync,
  getAllUserDetailsAsync,
} from "./settingsApi";

const initialState: SettingsInitialStatus<any, any> = {
  loading: false,
  manageLoading: false,
  UserDetails: [],
  userAccessLog: [],
  activityLog: [],
  countUserDetails: 0,
  countAccessLog: 0,
  countActivityLog: 0,
};

const settingsSlice = createSlice({
  name: "admin-settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllUserDetailsAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllUserDetailsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.UserDetails = action.payload.data;
        state.countUserDetails = action.payload.length;
      })
      .addCase(getAllUserDetailsAsync.rejected, (state) => {
        state.loading = false;
        state.UserDetails = [];
        state.countUserDetails = 0;
      });

    builder
      .addCase(getAllLoginAccessLogAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllLoginAccessLogAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.userAccessLog = action.payload.data;
        state.countAccessLog = action.payload.length;
      })
      .addCase(getAllLoginAccessLogAsync.rejected, (state) => {
        state.loading = false;
        state.userAccessLog = [];
        state.countAccessLog = 0;
      });

    // Activity Log
    builder
      .addCase(getActivityLogAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActivityLogAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.activityLog = action.payload.data;
        state.countActivityLog = action.payload.length;
      })
      .addCase(getActivityLogAsync.rejected, (state) => {
        state.loading = false;
        state.activityLog = [];
        state.countActivityLog = 0;
      });
  },
});

export default settingsSlice;
